import { FLOWS } from '../../../utils/constants';
import { SSR_GIG_COUNT_AI_CRAWLER, SSR_GIG_COUNT_DESKTOP, SSR_GIG_COUNT_MOBILE } from './constants';

interface GetSsrGigCountParams {
    /** `flow` from AppContext - a FLOWS.* value. NOT `flowName`, which is a different vocabulary. */
    flow?: string;
    inSsrGigCountTest?: boolean;
    isMobile?: boolean;
    /** A crawler that never runs JS, so the SSR'd HTML is all it will ever see. */
    isAiCrawler?: boolean;
    eagerImageOffset: number;
}

// Scoped to SC/NSC; every other flow returns `eagerImageOffset`, which is byte-identical to today.
export const getSsrGigCount = ({
    flow,
    inSsrGigCountTest,
    isMobile,
    isAiCrawler,
    eagerImageOffset,
}: GetSsrGigCountParams): number => {
    // A falsy offset already means "SSR every gig" downstream, so returning a fixed count here would
    // *lower* the SSR'd card count. This resolver may only ever raise it, never reduce it.
    if (flow !== FLOWS.CATEGORY || !eagerImageOffset) {
        return eagerImageOffset;
    }

    // Non-JS crawlers get the whole listing - they can never reach the rest by hydrating.
    // Checked before the A/B gate on purpose: crawlers are never allocated to experiments.
    if (isAiCrawler) {
        return SSR_GIG_COUNT_AI_CRAWLER;
    }

    if (!inSsrGigCountTest) {
        return eagerImageOffset;
    }

    return isMobile ? SSR_GIG_COUNT_MOBILE : SSR_GIG_COUNT_DESKTOP;
};
